import * as React from 'react';
import { Linked } from '@type-r/react';
import { Flex, PopupIODialog } from 'lqx-react';
import { InvoiceModel } from 'api/invoice';
import { makeStyles } from '@material-ui/core';
import { SocDialogType } from '.';

const DialogTitle = {
    'promiseToPay': 'Promise to Pay Date Change',
    'comment': 'Add Comment',
    'dispute': 'Add Dispute',
    'approve': 'Approve Dispute',
    'internalStatus': 'Internal Status'
};
const SuccessMessage = {
    'promiseToPay': 'Promise to pay date changed successfully',
    'comment': 'Comment added',
    'dispute': 'The selected invoices have been successfully sent for dispute',
    'approve': 'The selected invoices have been successfully sent for approval',
    'internalStatus': 'The selected invoices have been successfully updated'
};
const ActionButtonTitle = {
    'promiseToPay': 'Approve',
    'comment': 'Add',
    'dispute': 'Dispute',
    'approve': 'Approve',
    'internalStatus' : 'Save'
};

export const SocDialog = ({ $isOpen, invoices, dialogType, doIO, onSuccess, isValid, child }: {
    $isOpen: Linked<boolean>,
    invoices: InvoiceModel[],
    dialogType : SocDialogType,
    doIO?: () => Promise<void>,
    onSuccess?: () => void,
    isValid?: () => boolean,
    child?:JSX.Element
}) => {

    let styles = useStyles();

    return (
        <PopupIODialog
            $isOpen={$isOpen}
            title={DialogTitle[dialogType]}
            actionLabel={ActionButtonTitle[dialogType]}
            success={SuccessMessage[dialogType]}
            disabled={ isValid && !isValid() }
            onSuccess={ onSuccess }
            doIO={ doIO }
        >
            <Flex className={styles.popup}>
                {child}
                <br/>
            </Flex>
        </PopupIODialog>
    );
}

const useStyles = makeStyles({
    popup: {
        minHeight: 300
    }
});
